import * as React from "react";

import { nullElement } from "../../TypingUtils";

export interface ErrorBlockProps {
    hasErrors: boolean;
    children?: JSX.Element;
}

export function ErrorBlock(props: ErrorBlockProps): JSX.Element | null {
    return props.hasErrors ? <span>{props.children}</span> : nullElement;
}
